import $ from 'jquery';

export default class FlorDeAceite {
	constructor() {
		this.$section = $('.flor-de-aceite');
		this.$button = $('#florDeAceiteButton');
		this.$buttonText = this.$button.find('.flor-de-aceite_button-text');

		this.init();
	}

	init() {
		this.setupEventListeners();
	}

	setupEventListeners() {
		this.$button.on('click', () => {
			this.toggle();
		});
	}

	toggle() {
		this.$section.toggleClass('is-open');

		// ボタンテキストの切り替え
		if (this.$section.hasClass('is-open')) {
			this.$buttonText.text('close');
		} else {
			this.$buttonText.text('read more');
		}
	}
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
	new FlorDeAceite();
});
